export type DashboardTab =
  | 'leadership-pulse'
  | 'leadership-revenue'
  | 'leadership-margins'
  | 'leadership-cash'
  | 'leadership-compare'
  | 'leadership-sales'
  | 'leadership-people'
  | 'leadership-marketing'
  | 'leadership-scorecard'
  | 'kill-signals'

interface Tab {
  id: DashboardTab
  label: string
  shortLabel: string
}

const TABS: Tab[] = [
  { id: 'leadership-pulse', label: 'Executive Pulse', shortLabel: 'Pulse' },
  { id: 'leadership-revenue', label: 'Revenue Deep Dive', shortLabel: 'Revenue' },
  { id: 'leadership-margins', label: 'Margin & Cost Control', shortLabel: 'Margins' },
  { id: 'leadership-cash', label: 'Cash & Liquidity', shortLabel: 'Cash' },
  { id: 'leadership-compare', label: 'Period Comparison', shortLabel: 'Compare' },
  { id: 'leadership-sales', label: 'Sales Performance', shortLabel: 'Sales' },
  { id: 'leadership-people', label: 'People', shortLabel: 'People' },
  { id: 'leadership-marketing', label: 'Marketing', shortLabel: 'Marketing' },
  { id: 'leadership-scorecard', label: 'KPI Scorecard', shortLabel: 'KPIs' },
  { id: 'kill-signals', label: 'Kill Signals', shortLabel: 'Signals' },
]

interface LeadershipTabsProps {
  activeTab: DashboardTab
  onTabChange: (tab: DashboardTab) => void
  onViewCompany: () => void
}

function LeadershipTabs({ activeTab, onTabChange, onViewCompany }: LeadershipTabsProps) {
  return (
    <div className="leadership-tabs">
      <nav className="tab-bar">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'tab-active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            <span className="tab-label-full">{tab.label}</span>
            <span className="tab-label-short">{tab.shortLabel}</span>
          </button>
        ))}
      </nav>
      <button className="view-company-link" onClick={onViewCompany}>
        View Company Dashboard
      </button>
    </div>
  )
}

export default LeadershipTabs
